@if (label(); as label) {
  <label [attr.for]="uuid" class="text-xs font-medium text-foreground-primary-60"
    >{{ label }}
    @if (isRequired()) {
      <span class="text-status-error">*</span>
    }
  </label>
}

<div class="flex relative">
  @if (leftIcon(); as leftIcon) {
    <svg-icon
      [key]="leftIcon"
      [size]="leftIconSize()"
      class="absolute top-[50%] left-[12px] translate-y-[-50%] text-action-primary"
      [ngClass]="{
        'cursor-pointer': type() === 'time',
      }"
      (click)="type() === 'time' ? openTimePicker(timeInput) : null"
    ></svg-icon>
  }
  <input
    [attr.id]="inputId() ?? uuid"
    [type]="type()"
    [value]="value()"
    [readOnly]="readonly()"
    [placeholder]="placeholder() ?? ''"
    [attr.autocomplete]="autocomplete()"
    [attr.role]="inputRole()"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-autocomplete]="ariaAutocomplete()"
    [attr.aria-controls]="ariaControls()"
    [attr.aria-activedescendant]="ariaActiveDescendant()"
    [attr.aria-expanded]="ariaExpanded()"
    (input)="onInput($event)"
    (blur)="onBlur()"
    class="grow min-w-0 rounded-radius-cta bg-background-fixed placeholder:text-action-primary text-action-primary lg:text-sm font-semibold border"
    [ngClass]="[
      leftIcon() ? 'pl-[42px]' : 'pl-[12px]',
      clearable() ? 'pr-[36px]' : 'pr-[13px]',
      size() === 'large' ? 'h-[45px]' : 'h-[36px]',
      disabled()
        ? 'placeholder:[&&&]:text-custom-disabled-input-color [&&&]:text-custom-disabled-input-color [&&&&]:bg-custom-disabled-input-background'
        : '',
      inputClasses(),
      error() || isValid() === false ? 'border-status-error' : 'border-[transparent]',
    ]"
    [disabled]="disabled()"
    #inputElement
    #timeInput
  />
  @if (!errorInFlow()) {
    <div class="absolute top-[calc(100%_+_4px)] left-0 w-full text-xs font-medium text-status-error">
      {{ error() ?? '' }}
    </div>
  }

  @if (type() === 'time') {
    <div class="absolute h-full top-0 right-0 flex items-center text-action-primary pr-3 cursor-pointer">
      <svg-icon key="chevron-down-16" size="16" (click)="openTimePicker(timeInput)"></svg-icon>
    </div>
  }

  @if (clearable() && value() && !readonly() && !disabled()) {
    <button
      type="button"
      class="absolute h-full top-0 right-0 flex items-center text-action-primary pr-3 cursor-pointer bg-transparent border-0 p-0"
      (click)="clear()"
      aria-label="Clear"
    >
      <svg-icon key="close-16" size="16"></svg-icon>
    </button>
  }
</div>

@if (errorInFlow() && error(); as error) {
  <div class="w-full text-xs font-medium text-status-error">{{ error }}</div>
}
